import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export const getPolicies = async () => {
  return axios.get(endpoints.getPolicies)
}

export const useGetPolicies = () => {
  return useQuery([ApiKey.policies, ApiKey.list], () => getPolicies())
}
